module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/core/~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 515
// module chunks = 0